import React, { useEffect } from "react";

import Stories from "components/stories";

import { green } from "theme/colors";

const ForestTemplate = (props) => {
  //PROPS
  const {
    data: {
      page: { stories }
    },
    setColor
  } = props;
  //PROPS

  //USEEFFECTS
  useEffect(() => {
    setColor(false);

    return () => {
      setColor(true);
    };
  }, []);
  //USEEFFECTS

  return <Stories data={stories} color={green.default} />;
};

export const query = graphql`
  query Forest($id: String) {
    page: wpPage(id: { eq: $id }) {
      stories {
        slidess {
          title
          tips {
            tip
          }
          text
          image {
            altText
            localFile {
              childImageSharp {
                fluid(maxWidth: 2400, quality: 100) {
                  src
                  srcSet
                }
              }
            }
          }
        }
        mobileImage {
          altText
          localFile {
            childImageSharp {
              fluid(maxWidth: 2400, quality: 100) {
                src
                srcSet
              }
            }
          }
        }
        image {
          altText
          localFile {
            childImageSharp {
              fluid(maxWidth: 2400, quality: 100) {
                src
                srcSet
              }
            }
          }
        }
      }
    }
  }
`;
export default ForestTemplate;
